/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { ProcessQResponseMessage } from "../../../messages";
import { processPaymentQDataFormatter } from "./data.formatter";

export const getVIPUserList = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    const message: ProcessQResponseMessage = context?.message;
    try {
      const input = message?.raw?.parsed;
      if (input && Array.isArray(input)) {
        let filtered = input.filter(
          (o: any) =>
            o?.isVipToken === true && o?.isCalledOutByDistCounter === false
        );
        if (filtered) {
          filtered = filtered.sort((a: any, b: any) => {
            return b?.createdOn - a?.createdOn;
          });
          message.vipList = processPaymentQDataFormatter(filtered);
          message.queueHeader.vipValue = String(message.vipList.length);
        }
      }

      return resolve(true);
    } catch (err: any) {
      console.log(`error in formatQueueHeaderData error=${err?.message}`);
      return reject(err?.message);
    }
  });
};
